//日志
import _import from '@/utils/import'

const Layout = _import('layout/Layout')
let log = [
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'loginLog',
                component: _import('log/loginLog/index'),
                name: 'loginLog',
                meta: {
                    title: '平台登录日志',
                    icon: 'widgets'
                }
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'claimDetails',
                component: _import('log/claimDetails/index'),
                name: 'claimDetails',
                meta: {
                    title: '领取明细分析',
                    icon: 'widgets'
                }
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'developData',
                component: _import('log/developData/index'),
                name: 'developData',
                meta: {
                    title: '开发数据统计',
                    icon: 'widgets'
                }
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'developSumData',
                component: _import('log/developSumData/index'),
                name: 'developSumData',
                meta: {
                    title: '开发汇总数据',
                    icon: 'widgets'
                }
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'noLoginDetailsCustomer',
                component: _import('log/noLoginDetailsCustomer/index'),
                name: 'developData',
                meta: {
                    title: '未登录明细表',
                    icon: 'widgets'
                }
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'claimDetailsCustomer',
                component: _import('log/claimDetailsCustomer/index'),
                name: 'developData',
                meta: {
                    title: '领取明细分析',
                    icon: 'widgets'
                }
            }
        ]
    },
    {
        path: '',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'developDataCustomer',
                component: _import('log/developDataCustomer/index'),
                name: 'developData',
                meta: {
                    title: '开发数据统计',
                    icon: 'widgets'
                }
            }
        ]
    },
]
export default log
